import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectLimitReached } from 'store/Host/selectors';
import { useIntl } from 'react-intl';
import { selectIsReadOnly } from 'store/Faraday/selectors';
import { FEATURE_BULK_CREATE, FEATURE_HOSTS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { selectActiveWorkspacesCount } from 'store/Global/selectors';
import { openModal } from 'store/modals/actions';
import { MODAL_CANT_CREATE } from 'store/modals/modals';
import { RiFileDownloadLine as DownloadLine, RiFileEditLine as EditLine } from 'react-icons/ri';
import useClickOutside from 'Hooks/useClickOutside';
import AddButton from 'shared/ui/AddButton';
import ImportFileCreationModal from 'Screens/Contextualization/ManageEditCreate/components/ImportFileCreationModal';
import { getWorkspaces } from 'Screens/Contextualization/Workspaces/actions/Actions';
import {
  Dropdown, DropdownItem, Wrapper
} from './styled';

const CreateActions = ({ setVisibilityCreateModal, entity }) => {
  const [showImportModal, setShowImportModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef();
  const intl = useIntl();
  const addText = intl.formatMessage({ id: 'host.create' });
  const limitReached = useSelector(selectLimitReached);
  const readOnly = useSelector(selectIsReadOnly);
  const manualCreationAllowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_HOSTS, PERMISSION_TYPES.CREATE));
  const importAllowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_BULK_CREATE, PERMISSION_TYPES.CREATE));
  const isWritable = entity === 'assetsGeneral' || !readOnly;
  const canShowManualCreation = isWritable && !limitReached && manualCreationAllowedByRole;
  const canShowImportFromFile = isWritable && !limitReached && importAllowedByRole;
  const disabledButton = !canShowManualCreation && !canShowImportFromFile;
  const activeWorkspacesCount = useSelector(selectActiveWorkspacesCount);
  const dispatch = useDispatch();

  useClickOutside(dropdownRef, () => setShowDropdown(false));

  const handleShow = () => {
    if (entity === 'assetsGeneral' && !activeWorkspacesCount) {
      dispatch(openModal(MODAL_CANT_CREATE));
    } else if (canShowManualCreation) {
      setVisibilityCreateModal(true);
    }
    setShowDropdown(false);
  };

  const handleShowImportFromFile = () => {
    setShowImportModal(true);
    setShowDropdown(false);
    if (entity === 'assetsGeneral') dispatch(getWorkspaces(false, false));
  };

  const handleDropdown = () => {
    if (!disabledButton) setShowDropdown(!showDropdown);
  };

  return (
    <Wrapper ref={ dropdownRef }>
      <AddButton disabled={ disabledButton } onClick={ handleDropdown } title={ addText }>
        { addText }
      </AddButton>
      { showDropdown &&
        <Dropdown>
          { canShowManualCreation &&
            <DropdownItem onClick={ handleShow } role="button" aria-label="Manual Creation" type="button">
              <EditLine size="1.3em" color="#5a6b7d" />
              Manual Creation
            </DropdownItem>
          }
          { canShowImportFromFile &&
            <DropdownItem onClick={ handleShowImportFromFile } role="button" aria-label="Import from File" type="button">
              <DownloadLine size="1.3em" color="#5a6b7d" />
              Import from File
            </DropdownItem>
          }
        </Dropdown>
      }
      { showImportModal &&
        <ImportFileCreationModal
          entity={ entity }
          handleClose={ () => setShowImportModal(false) }
        />
      }
    </Wrapper>
  );
};

export default CreateActions;
